<template>
  <div class="sort-dropdown" ref="dropdownMenu" v-on:click="toggleDropdown" >
    <button class="sort-dropdown__current" v-bind:class="{ open : isOpen }" 
            v-on:keyup.down.stop="focusNext" 
            v-on:keyup.esc="toggleDropdown">
      {{ label }} 
      <i class="icon-angle-down sort-dropdown__icon" v-bind:class="{ open : isOpen }"></i>
    </button>
    <div class="sort-dropdown__options" v-show="isOpen">
      <div v-for="option in sortOptions" class="sort-dropdown__option" :key="option.Alias" tabindex="0"
            v-on:keydown = "stopScroll($event)"
            v-on:keyup.stop.prevent="keyEventManager($event)">
        <input type="radio" class="sort-dropdown__input" :id="option.Alias" :value="option.Alias" v-model="picked">
        <label class="sort-dropdown__label" :for="option.Alias">
          {{ option.Name }}
        </label>
      </div>
    </div>
  </div>  
</template>

<script>
import axios from 'axios';

export default {
    name: 'SortDropdown',
    props: ['submit', 'value'],
    data() {
        return {
            label: 'Sort by',
            isOpen: false,
            sortOptions: []
        }
    },
    created() {
        axios.get("/umbraco/surface/api/getorderbyitems")
            .then(response => this.sortOptions = response.data)
            .catch(error => console.log(error));

        document.addEventListener('click', this.documentClick);
    },
    computed: {
        picked: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
                this.submit();
                this.isOpen = false;
            }
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        documentClick(e) {
            let el = this.$refs.dropdownMenu;
            let target = e.target;
            if ((el !== target) && !el.contains(target)) {
                this.isOpen = false;
            }
        },
        focusNext: function () {
            
            var currentElement = document.activeElement;
            var children = this.$refs.dropdownMenu.querySelectorAll('[tabindex]:not([tabindex="-1"])');
            var currentIndex = this.getCurrentElementIndex(children, currentElement);

            var nextIndex = currentIndex + 1;
            if (nextIndex >= children.length) {
                nextIndex = 0;
            }

            var nextElement = children[nextIndex];
            nextElement.focus();
        },
        focusPrevious: function () {

            var currentElement = document.activeElement;
            var children = this.$refs.dropdownMenu.querySelectorAll('[tabindex]:not([tabindex="-1"])');
            var currentIndex = this.getCurrentElementIndex(children, currentElement);

            var nextIndex = currentIndex - 1;
            if (nextIndex < 0) {
                nextIndex = children.length - 1;
            }

            var previousElement = children[nextIndex];
            previousElement.focus();
        },
        getCurrentElementIndex: function (children, currentElement) {
            var i = children.length - 1;
            for (; i >= 0; i--) {
                if (currentElement == children[i]) {
                    break;
                }
            }
            return i;
        },
        selectOption: function () {
            var selectednode = document.activeElement;
            var option = selectednode.childNodes[0].value;

            if (this.picked != option) {
                this.picked = option;
            }
        },

        keyEventManager: function (e) {
            switch (e.key) {
                case ('ArrowDown'): {
                    this.focusNext();
                    break;
                }
                case ('ArrowUp'): {
                    this.focusPrevious();
                    break;
                }
                case ('Enter'): {
                    this.selectOption();
                    break;
                }
                case ('Escape'): {
                    this.toggleDropdown();
                    break;
                }
                default: {
                    break;
                }
            }
        },
        stopScroll: function (e) {
            e.preventDefault();
        }
    },
    destroyed() {
        document.removeEventListener('click', this.documentClick);
    }
}
</script>

<style lang="scss" scoped>
@import "src/scss/variables";
.sort-dropdown {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: $main-font;
    position: relative;
 
    &__current {
        height: 40px;
        padding: 0 20px;
        border: 2px solid;
        border-radius: 5px;
    }

    &__options {
      position: absolute;
      bottom: -10px;
      right: -2px;
      -webkit-transform: translateY(100%);
      transform: translateY(100%);
      border: 2px solid;
      border-radius: 5px;
      z-index: 100;
    }

    &__label {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 40px;
      padding: 0 20px;
      text-decoration: none;
      transition: all 0.2s;
      white-space: nowrap;
      
      i {
        margin-left: 10px;
      }
    }
    &__input {
      position: absolute;
      visibility: hidden;
    }
    &__icon {
      margin-left: 10px;
      transition: all 0.2s;
      &.open {
        position: relative;
        transform: rotate(180deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/SortDropdown.vue